import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment, setEnvironment } from '@ov-suite/helpers-shared';
import Amplify from '@aws-amplify/core';
import moment from 'moment';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import { AppModule } from './app/app.module';

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () {
  return moment(this).format();
};

fetch('/assets/config.json', {
  method: 'GET',
})
  .then(function(response) {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(response);
  })
  .then(function(data) {
    console.log(data);
    localStorage.setItem('config', JSON.stringify(data));

    if (data.production) {
      enableProdMode();
    }
    setEnvironment(data);

    Sentry.init({
      dsn: 'https://0b7b4582bf074070bce339393d86b0c5@sentry.linksuite.io/2',
      integrations: [
        new Integrations.BrowserTracing({
          tracingOrigins: ['localhost', environment.values.apiUrl.idm],
          routingInstrumentation: Sentry.routingInstrumentation,
        }),
      ],

      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      release: 'yardlink-web-1.2.3',
      environment: environment?.values?.webUrl?.admin ? environment.values.webUrl.idm : 'dev',
      tracesSampleRate: 1.0,
    });

    Amplify.configure({
      aws_project_region: data.cognito.region,
      aws_cognito_identity_pool_id: data.cognito.identityPoolId,
      aws_cognito_region: data.cognito.region,
      aws_user_pools_id: data.cognito.userPoolId,
      aws_user_pools_web_client_id: data.cognito.clientId,
      oauth: data.cognito.oauth,
      aws_user_files_s3_bucket: data.cognito.bucketId,
      aws_user_files_s3_bucket_region: data.cognito.region,
    });

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(function(error) {
    console.warn('Something went wrong.', error);
  });
